module.exports = __webpack_public_path__ + "dist/img/we.91ba5945.svg";